import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { UsersIcon, ShieldIcon, ClockIcon, DollarIcon } from './Icons';
export const TrustFactors = () => {
  const {
    t
  } = useLanguage();
  const icons = [<UsersIcon className="w-7 h-7" data-id="element-906" />, <ShieldIcon className="w-7 h-7" data-id="element-907" />, <ClockIcon className="w-7 h-7" data-id="element-908" />, <DollarIcon className="w-7 h-7" data-id="element-909" />];
  const accentColors = ['from-brand-red to-red-800', 'from-brand-yellow to-yellow-600', 'from-brand-red to-red-800', 'from-brand-yellow to-yellow-600'];
  return <section className="py-24 bg-brand-dark relative overflow-hidden" data-id="element-910">
      {/* Diagonal background accent */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-911">
        <div className="absolute -top-1/2 -right-1/4 w-[800px] h-[800px] bg-brand-red/5 rounded-full blur-3xl" data-id="element-912" />
        <div className="absolute -bottom-1/2 -left-1/4 w-[600px] h-[600px] bg-brand-yellow/5 rounded-full blur-3xl" data-id="element-913" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-914">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-915">
          <div className="inline-flex items-center gap-2 bg-brand-red/10 border border-brand-red/20 rounded-full px-5 py-2 mb-6" data-id="element-916">
            <ShieldIcon className="w-4 h-4 text-brand-red" data-id="element-917" />
            <span className="text-brand-red text-sm font-bold uppercase tracking-wider" data-id="element-918">
              {t.trust.title}
            </span>
          </div>
        </motion.div>

        <div className="space-y-0" data-id="element-919">
          {t.trust.factors.map((factor: any, index: number) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -40 : 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className={`flex items-stretch ${index % 2 === 0 ? '' : 'md:flex-row-reverse'}`} data-id="element-920">
              {/* Number + Icon column */}
              <div className="hidden md:flex flex-col items-center w-28 flex-shrink-0 relative" data-id="element-921">
                {/* Vertical line */}
                {index > 0 && <div className="w-px h-8 bg-white/10" data-id="element-922" />}
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${accentColors[index]} flex items-center justify-center text-white shadow-lg relative z-10`} data-id="element-923">
                  {icons[index]}
                </div>
                {index < t.trust.factors.length - 1 && <div className="w-px flex-1 bg-white/10" data-id="element-924" />}
              </div>

              {/* Content */}
              <div className={`flex-1 py-6 ${index % 2 === 0 ? 'md:pl-6' : 'md:pr-6 md:text-right'}`} data-id="element-925">
                <div className={`relative group ${index % 2 === 0 ? 'md:border-l-2 md:border-brand-red/30 md:pl-8' : 'md:border-r-2 md:border-brand-yellow/30 md:pr-8'}`} data-id="element-926">
                  {/* Large background number */}
                  <span className={`absolute top-0 font-oswald text-[120px] leading-none font-bold text-white/[0.03] select-none pointer-events-none ${index % 2 === 0 ? '-left-2' : '-right-2'}`} data-id="element-927">
                    0{index + 1}
                  </span>

                  {/* Mobile icon */}
                  <div className={`md:hidden mb-4 inline-flex w-12 h-12 rounded-xl bg-gradient-to-br ${accentColors[index]} items-center justify-center text-white`} data-id="element-928">
                    {icons[index]}
                  </div>

                  <div className="relative z-10" data-id="element-929">
                    <span className={`text-xs font-bold uppercase tracking-[0.2em] mb-2 block ${index % 2 === 0 ? 'text-brand-red' : 'text-brand-yellow'}`} data-id="element-930">
                      0{index + 1}
                    </span>
                    <h3 className="font-oswald text-2xl md:text-3xl font-bold text-white mb-3 uppercase" data-id="element-931">
                      {factor.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed text-lg max-w-lg" data-id="element-932">
                      {factor.desc}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};